/**
 * DomHelper — DOM 操作ユーティリティ
 * WordPress 移植時も同様のロジックで再利用可能な形に保つ
 */
// biome-ignore lint/complexity/noStaticOnlyClass: utility class pattern intentional
export class DomHelper {
  /** querySelector の型安全ラッパー */
  static qs<T extends Element>(selector: string, parent: ParentNode = document): T | null {
    return parent.querySelector<T>(selector);
  }

  /** querySelectorAll → 配列変換 */
  static qsa<T extends Element>(selector: string, parent: ParentNode = document): T[] {
    return Array.from(parent.querySelectorAll<T>(selector));
  }

  /** class の追加・削除・トグル */
  static addClass(el: Element, ...classes: string[]): void {
    el.classList.add(...classes);
  }

  static removeClass(el: Element, ...classes: string[]): void {
    el.classList.remove(...classes);
  }

  static toggleClass(el: Element, className: string, force?: boolean): void {
    el.classList.toggle(className, force);
  }

  static hasClass(el: Element, className: string): boolean {
    return el.classList.contains(className);
  }

  /** data 属性取得 */
  static getData(el: HTMLElement, key: string): string {
    return el.dataset[key] ?? '';
  }

  /** aria 属性 */
  static setAria(el: Element, key: string, value: string): void {
    el.setAttribute(`aria-${key}`, value);
  }

  static getAria(el: Element, key: string): string {
    return el.getAttribute(`aria-${key}`) ?? '';
  }

  /** body の data-page を取得 */
  static getPageName(): string {
    return document.body.dataset.page ?? '';
  }

  /** scroll ロック */
  static lockScroll(): void {
    const scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  }

  static unlockScroll(): void {
    const scrollY = Math.abs(Number.parseInt(document.body.style.top || '0', 10));
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  /** Intersection Observer のラッパー */
  static createObserver(
    callback: IntersectionObserverCallback,
    options?: IntersectionObserverInit
  ): IntersectionObserver {
    return new IntersectionObserver(callback, {
      rootMargin: '0px 0px -80px 0px',
      threshold: 0.1,
      ...options,
    });
  }

  /** GTM / GA4 イベント発火ヘルパー */
  static pushDataLayer(eventData: Record<string, unknown>): void {
    // biome-ignore lint/suspicious/noExplicitAny: dataLayer requires any for GTM compatibility
    const w = window as any;
    w.dataLayer = w.dataLayer ?? [];
    w.dataLayer.push(eventData);
  }
}
